import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import Wangeditor from '../../components/Wangeditor/index';
import { Form, Input, Button, message, Checkbox, Radio } from 'antd';
import Pictures from '../Pictures/index';
import services from '../../services/api';
import './index.less';

const { TextArea } = Input;
class AdsAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {}
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
    this.api = 'ads';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname.indexOf('edit') !== -1) {
      if (nextProps.match.params.id !== this.id) {
        this.id = nextProps.match.params.id;
        this.getDetail();
      }
    }
  }

  /**获取详情 */
  getDetail = () => {
    services[this.api].queryOne({ id: this.id }).then(data => {
      console.log(data);
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          title: data.data.title,
          des: data.data.des,
          cname: data.data.cname,
          content: { html: data.data.content }
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      const params = {
        ...values,
        ads_id: this.props.adsId
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services[this.api][this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.history.push(this.getListUrl());
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    console.log('id', this.id);
    const formItems1 = [
      {
        label: {
          label: '名称',
          className: 'tantuer-form-item'
        },
        name: 'title',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入名称' }]
        },
        component: <Input placeholder="名称" className="large" />
      },

      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            <div className="ant-row ant-form-item tantuer-form-item">
              <div className="ant-form-item-label">
                <label title="图片管理">图片管理</label>
              </div>
              <div className="pic-area">
                <Pictures adsId={this.id} />
              </div>
            </div>
          </div>
          {this.actionType === 'add' && (
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              提交
            </Button>
          )}
        </Form>
      </div>
    );
  }
}

export default Form.create()(AdsAdd);
